import { create } from 'zustand';
import Cookies from 'js-cookie';

type State = {
  authAdminToken: string | null;
};

type Action = {
  setAuthAdminToken: (token: string | null) => void;
};

const useAdminAuthStore = create<State & Action>((set) => ({
  authAdminToken: Cookies.get('admin_token') || null,
  setAuthAdminToken: (token) => set({ authAdminToken: token }),
}));

export default useAdminAuthStore;
